import { JsonObject } from '@/lib/helpers';

export type TelemetrySourceTypes = 'user-event' | 'audit-event';

export class TelemetrySources {
  userEvents: TelemetrySourceUserEvent;
  auditEvents: TelemetrySourceAuditEvent;

  constructor(props: JsonObject = {}) {
    const data = props as Record<keyof TelemetrySources, unknown>;
    this.userEvents = new TelemetrySourceUserEvent(data.userEvents as JsonObject);
    this.auditEvents = new TelemetrySourceAuditEvent(data.auditEvents as JsonObject);
  }
}

export class TelemetrySourceUserEvent {
  enabled: boolean;
  schemaVersion: string;
  includeConversationData?: boolean;

  constructor(props: JsonObject = {}) {
    const data = props as Record<keyof TelemetrySourceUserEvent, unknown>;

    this.enabled = !!data.enabled;
    this.schemaVersion = (data.schemaVersion as string) || 'v1';
    this.includeConversationData = !!data.includeConversationData;
  }
}

export class TelemetrySourceAuditEvent {
  enabled: boolean;
  schemaVersion: string;

  constructor(props: JsonObject = {}) {
    const data = props as Record<keyof TelemetrySourceAuditEvent, unknown>;

    this.enabled = !!data.enabled;
    this.schemaVersion = (data.schemaVersion as string) || 'v1';
  }
}
